import {Contractor} from '../contractor';

export function toString(this: Contractor) {
    return `Deal: ${this.id}`;
}
